import React, { Component } from 'react'
import { connect } from 'react-redux'
import { UserCreate as UserCreate24 } from 'projects/flow-gui-access/views/2.4/users'

class UserCreate extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'users').length !== 0) {
      return <UserCreate24 {...this.props} />
    } else {
      return null
    }
  }
}

export default connect(state => state)(UserCreate)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/users/create.js